module.exports = "/static/fonts/OpenSans-Bold.woff2";